export enum LimitType {
  Deposit = 1,
  CasinoWagering = 2,
  CasinoNetLoss = 3,
  SportsWagering = 4,
  SportsNetLoss = 5,
  Session = 6,
  StakePerSession = 7,
  MaxStakePerBet = 8,
  NetLoss = 9,
  Wagering = 10,
  NetDeposit = 11,
  Affordability = 12,
}
